import { Icon, MenuItem } from "@mui/material";
import { theme } from "../../config/theme";
import CoreOutlinedButton from "../../core/inputs/CoreOutlinedButton";
import {
  DELETE_VALIDATIONS_ERROR,
  DELETE_VALIDATIONS_SUCCESS,
  GET_VALIDATIONS_ERROR,
  GET_VALIDATIONS_SUCCESS,
} from "../../store/types/billTypes";
import { useDispatch, useSelector } from "react-redux";
import CoreDataTable from "../../core/dataDisplay/datatable/CoreDataTable";
import {
  API_METHOD_GET,
  API_METHOD_PUT,
  ENTITY_STATUS,
} from "../../config/constants";
import { useEffect, useState } from "react";
import { api_request } from "../../store/actions/commonAction";
import CoreH4 from "../../core/dataDisplay/CoreH4";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import { useNavigate } from "react-router";
import CoreH6 from "../../core/dataDisplay/CoreH6";
import moment from "moment";
import CoreModal from "../../core/layouts/CoreModal";
import ValidationFlowChart from "./ValidationFlowChart";

export default function GetValidations(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const validations = useSelector((state) => state.validation.validations);
  const deleteValidationSuccess = useSelector(
    (state) => state.validation.deleteValidationSuccess,
  );

  useEffect(() => {
    getValidations();
    return () => {};
  }, []);

  useEffect(() => {
    if (deleteValidationSuccess) {
      getValidations();
    }
    return () => {};
  }, [deleteValidationSuccess]);

  const getValidations = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/validations",
        {},
        {},
        null,
        GET_VALIDATIONS_SUCCESS,
        GET_VALIDATIONS_ERROR,
        true,
        false,
      ),
    );
  };

  const deleteValidation = (row) => {
    dispatch(
      api_request(
        API_METHOD_PUT,
        "/validation/delete",
        { id: row?.id },
        {},
        null,
        DELETE_VALIDATIONS_SUCCESS,
        DELETE_VALIDATIONS_ERROR,
        true,
        false,
      ),
    );
  };

  console.log(validations);
  return (
    <div>
      <CoreModal
        title="Logic Flow"
        open={open}
        handleClose={() => {
          setModal(false);
        }}
        width="40vw"
      >
        <div style={{ height: 400 }}>
          <ValidationFlowChart
            data={[
              {
                data: modalData?.schema?.logic,
                logicText: modalData?.schema?.logicText,
              },
            ]}
          />
        </div>
      </CoreModal>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <CoreH6>Current Validations</CoreH6>
        <CoreContainedButton
          onClick={() => {
            navigate("/validation/add");
          }}
        >
          Add Validation
        </CoreContainedButton>
      </div>
      <CoreDataTable
        id="validationList"
        selectable={false}
        actions={[]}
        rowActions={[
          {
            icon: "visibility",
            onClick: (row) => {
              setModalData(row);
              setModal(true);
            },
          },
          {
            icon: "delete",
            onClick: deleteValidation,
          },
        ]}
        columns={[
          // {
          //   view: (row) => {
          //     return row._status === ENTITY_STATUS.processing ? (
          //       <Icon title="processing" sx={{ fontSize: 16 }}>
          //         autorenew
          //       </Icon>
          //     ) : (
          //       ""
          //     );
          //   },
          //   name: "",
          //   label: "",
          // },
          {
            name: "docType",
            label: "Document type",
            view: (row) => {
              return row?.name?.split("-")[0];
            },
          },
          {
            name: "fields",
            label: "Fields",
            view: (row) => {
              return row?.name?.split("-")[0];
            },
          },
          {
            name: "Description",
            label: "Description",
            view: (row) => {
              return row?.schema?.logicText;
            },
          },
          {
            name: "createdAt",
            label: "Created on",
            view: (row) => {
              return moment(row.createdAt).format("DD-MM-YYYY, hh:mm");
            },
          },
        ]}
        dataRows={validations || []}
        searchable={true}
      />
    </div>
  );
}
